export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  schema?: Record<string, any>;
}

export const updateSEO = (data: SEOData) => {
  // Update title
  document.title = data.title;

  // Update or create meta tags
  const updateMetaTag = (name: string, content: string, isProperty = false) => {
    const attribute = isProperty ? 'property' : 'name';
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    
    element.setAttribute('content', content);
  };

  // Basic meta tags
  updateMetaTag('description', data.description);
  updateMetaTag('keywords', data.keywords);

  // Open Graph tags
  updateMetaTag('og:title', data.ogTitle || data.title, true);
  updateMetaTag('og:description', data.ogDescription || data.description, true);
  updateMetaTag('og:type', data.ogType || 'website', true);
  updateMetaTag('og:url', data.canonical, true);

  // Twitter Card tags
  updateMetaTag('twitter:title', data.ogTitle || data.title);
  updateMetaTag('twitter:description', data.ogDescription || data.description);

  // Update canonical link
  let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = data.canonical;

  // Update last-modified
  const today = new Date().toISOString().split('T')[0];
  updateMetaTag('last-modified', today);

  // Add or update Schema.org JSON-LD
  if (data.schema) {
    let schemaScript = document.querySelector('script[type="application/ld+json"][data-page-schema]');
    
    if (!schemaScript) {
      schemaScript = document.createElement('script');
      schemaScript.setAttribute('type', 'application/ld+json');
      schemaScript.setAttribute('data-page-schema', 'true');
      document.head.appendChild(schemaScript);
    }
    
    schemaScript.textContent = JSON.stringify(data.schema);
  }
};

export const getSiteUrl = (): string => {
  return import.meta.env.VITE_SITE_URL || 'https://example.com';
};
